export const LOGIN_REQUEST = "auth/loginRequest";
export const LOGIN_SUCCESS = "auth/loginSuccess";
export const LOGIN_ERROR = "auth/loginError";
export const LOGOUT = "auth/logout";
